import React from 'react';
import { ButtonViewProps } from '../../actions/Button/Button.view';
import { MandatoryChildren } from '../../../models/children-props';
import classNames from 'classnames';
import classes from './ButtonGroup.module.scss';
import { capitalizeString } from '../../../helpers/capitalizeString';

export type ButtonGroupViewProps = MandatoryChildren & {
  //
  size: ButtonViewProps['size'];
};

export const ButtonGroupView = (props: ButtonGroupViewProps): JSX.Element => {
  const mainClasses = classNames(classes.ButtonGroup, classes[`${capitalizeString(props.size)}ButtonGroupNoGaps`]);
  return <div className={mainClasses}>{props.children}</div>;
};
